import React from 'react';
import { Tooltip } from './images/svg/icons';
import GenericTooltip from './generictooltip';
import { useTranslation } from 'react-i18next';

interface AllowanceSectionProps {
    label: string;
    value: number;
    currency: string;
    tooltipActiveId: string | null;
    setTooltipActiveId: (id: string | null) => void;
    name: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checked: boolean;
    tooltipLabel: string;
    isShowTooltip?: boolean;
}

const AllowanceSection: React.FC<AllowanceSectionProps> = ({
    label,
    value,
    tooltipActiveId,
    isShowTooltip = true,
    setTooltipActiveId,
    name,
    currency,
    onChange,
    tooltipLabel
}) => {
    const { t } = useTranslation();
    return (
        <div className="mb-2">
            <label className="form-label me-2">{t(label)}</label> 
            {isShowTooltip && (
                <img
                    src={Tooltip}
                    className="tooltip-svg cursor-pointer"
                    onClick={() => setTooltipActiveId(name)}
                    alt=""
                />
            )}
            <GenericTooltip
                isActive={tooltipActiveId === name}
                content={t(tooltipLabel)}
                onClose={() => setTooltipActiveId(null)}
                width="w-50"
                position="left-0"
                zIndex="z-index-9"
            />
            <div className="form-group border-0 d-flex flex-grow-1 mb-0">
                <div className="d-flex rounded align-items-center">
                    <div
                        className="d-flex border-color-gray align-items-center justify-content-center w-100 position-relative"
                        style={{ borderRadius: '6px', border: '1px solid #EAEBF0' }}
                    >
                        <input
                            type="number"
                            className="form-control border-0 p-0 px-2 shadow-none mb-0"
                            placeholder="0"
                            value={value || ''}
                            onChange={onChange}
                            style={{ flex: 1 }}
                        />
                        <>
                            <div style={{
                                width: '1px',
                                height: '46px',
                                background: '#EAEBF0',
                                // margin: '0 8px'
                            }} />
                            <span className='px-2' style={{ color: 'rgba(24, 29, 39, 1)', fontSize: '16px', opacity: 0.5 }}>{currency}</span>
                        </>
                        {/* <span className='px-2'>
                            {currency}
                        </span> */}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AllowanceSection;
